import { Modal } from 'antd-mobile';
import { isHaojieApp } from 'api/Helper';

const alert = Modal.alert;

// 使用方法
// import {Alert} from 'commons/Modal';
// Alert('', '交易密码失败，请重试', [
// { text: '忘记密码', onPress: () => console.log('cancel'), style: 'default' },
// { text: '重试', onPress: () => console.log('ok'), style: { fontWeight: 'bold' } },
// ])
let _Alert = null;
function Alert(...options) {
    // 好借app内，只展示更新好借app的modal，其它的调用一律禁用掉
    if (isHaojieApp()) return _Alert;
    _Alert = alert(...options);
    return _Alert;
}

Alert.close = function () {
    if (_Alert) {
        _Alert.close();
        _Alert = null;
    }
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components_common/Modal/Alert.js